import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '@environments/environment';
import { AzureSpeechSettings } from '@models/azure/azure-speech-settings';
import { ClinicsService } from './clinics.service';
import { BlobService } from './blob.service';
import { ConsultationFileType } from '@models/consultation-file-type.enum';
import { NoteAudioType } from '@models/note-audio-type.enum';
import { map, switchMap } from 'rxjs/operators';
import { removeURIQueryString } from '@app/lib/fun';
import { dataURLtoFile } from '@app/shared/helpers';
import moment from 'moment';

@Injectable({
  providedIn: 'root',
})
export class SpeechService {
  constructor(private http: HttpClient, private clinicsService: ClinicsService, private blobService: BlobService) {}

  getAzureSpeechSettings() {
    return this.http.get<AzureSpeechSettings>(environment.baseUrl + 'api/Speech/GetSettings');
  }

  async generateSummary(transcript: string): Promise<{ summary: string }> {
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');

    return new Promise((resolve, reject) => {
      this.http
        .post<{ summary: string }>('/api/Speech/GenerateSummary', JSON.stringify(transcript), { headers })
        .subscribe({
          next: (response) => resolve(response),
          error: (error) => reject(error),
        });
    });
  }

  addAudioToBlob(base64Audio: string, patientId: number, consultationAudioType: NoteAudioType) {
    const clinicUrl = this.clinicsService.clinicUrl;
    const filePath = `${clinicUrl}patients/audio/`;
    const consultationType = consultationAudioType === NoteAudioType.Consultation ? 'consultation' : 'dictation';
    const fileName = `${moment(new Date()).format('YYYYMMDD-hhmmssA')}-${consultationType}.mp3`;
    const filePathAndName = filePath + `${patientId}/${fileName}`;

    const file = dataURLtoFile(base64Audio, fileName);

    return this.blobService
      .uploadFileToBlobStorage(file, filePathAndName, {
        // This options object is purely here to allow you to have a progress function that may update the UI otherwise you can remove it
        progress: (progress) => {
          // TODO: Do something with percent if you want
          // const percent = progress.loadedBytes / doc.file.size;
        },
      })
      .pipe(
        map((blobURI) => {
          return removeURIQueryString(blobURI);
        })
      );
  }
}
